var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIotHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 107,
    viewBox: "0 0 185 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_731_8139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 70.87V22.68C0 10.2 10.2 0 22.68 0H76.72V48.19C76.72 60.66 66.52 70.87 54.04 70.87H0Z",
    fill: "#C7282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.68 8.5C14.86 8.5 8.51001 14.86 8.51001 22.67V62.36H54.04C61.85 62.36 68.21 56 68.21 48.19V8.5H22.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.44 53.27H17.25V30.77H21.44V53.27V53.27Z",
    fill: "#C7282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.52 45.4101C42.52 51.5001 41.71 53.4501 35.33 53.4501C28.95 53.4501 28.14 51.5001 28.14 45.4101C28.14 39.3201 28.95 37.3401 35.33 37.3401C41.71 37.3401 42.52 39.2901 42.52 45.4101ZM31.81 45.4401C31.81 49.6401 32.07 50.5701 35.33 50.5701C38.59 50.5701 38.85 49.6401 38.85 45.4401C38.85 41.2401 38.59 40.2201 35.33 40.2201C32.07 40.2201 31.81 41.1801 31.81 45.4401V45.4401Z",
    fill: "#C7282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.62 53.27H51.43V34.46H45.02V30.77H62.02V34.46H55.62V53.27V53.27Z",
    fill: "#C7282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23999 87.02H2.85999V106.12H6.23999V87.02Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.81 86.8201H18.69C13.89 86.8201 11.93 88.9301 11.93 94.0901V99.0401C11.93 104.21 13.89 106.31 18.69 106.31H28.81C33.61 106.31 35.57 104.2 35.57 99.0401V94.0901C35.57 88.9201 33.61 86.8201 28.81 86.8201V86.8201ZM32.19 93.1701V99.9701C32.19 102.35 31.14 103.32 28.57 103.32H18.94C16.37 103.32 15.32 102.35 15.32 99.9701V93.1701C15.32 90.7901 16.37 89.8201 18.94 89.8201H28.57C31.14 89.8201 32.19 90.7901 32.19 93.1701Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.29 90.02H48.17V106.11H51.54V90.02H60.42V87.02H39.29V90.02Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05 101.8L83.05 87.02H78.58V106.11H81.95V91.28L91.93 106.11H94.17L104.15 91.28V106.11H107.52V87.02H103.05L93.05 101.8Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.85 97.79H131.14V94.79H116.85V90.02H131.72V87.02H113.47V106.11H131.82V103.11H116.85V97.79Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.54 94.9201H143.5C139.79 94.9201 139.63 94.1901 139.63 92.5401C139.63 90.2001 140.43 89.8201 145.34 89.8201H147.86C153.89 89.8201 153.89 90.2101 153.93 92.7301V93.2201H157.16V92.1001C157.16 88.2601 155.03 86.8301 149.28 86.8301H144.16C139.23 86.8301 136.38 87.7401 136.38 92.3801C136.38 97.8801 139.67 98.1301 146.51 98.1301H151.02C153.92 98.1301 154.35 98.6601 154.35 100.48C154.35 102.62 153.78 103.33 150.39 103.33H143.01C139.88 103.33 139.63 102.37 139.63 101.21V99.4401H136.4V101.26C136.4 106.33 141.32 106.33 143.43 106.33H150.03C152.86 106.33 157.59 106.33 157.59 101.06V99.8901C157.59 96.4701 155.41 94.9401 150.52 94.9401L150.54 94.9201Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.49 87.02V94.79H166.62V87.02H163.24V106.11H166.62V97.79H181.49V106.11H184.86V87.02H181.49Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_731_8139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184.86,
    height: 106.31,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIotHeader);
export default __webpack_public_path__ + "static/media/logo_iot_header.14ffd7c84dc9586c348595d487945b1f.svg";
export { ForwardRef as ReactComponent };